// 生成随机字符串
function randomString(length = 8) {
  return Math.random().toString(36).substring(2, length + 2)
}

// 生成随机手机号
function randomPhone() {
  const prefixes = ['133', '138', '135', '139', '150', '151', '152', '158', '156', '157', '159', '188', '187', '182', '183']
  const prefix = prefixes[Math.floor(Math.random() * prefixes.length)]
  const suffix = Math.floor(Math.random() * 100000000).toString().padStart(8, '0')
  return prefix + suffix
}

// 生成随机域名
function randomDomain() {
  const prefixes = ['www', 'app', 'web', 'api', 'dev', 'test', 'admin', 'portal', 'cloud', 'service']
  const domains = ['example.com', 'test.com', 'demo.com', 'company.com', 'tech.com']
  const prefix = prefixes[Math.floor(Math.random() * prefixes.length)]
  const domain = domains[Math.floor(Math.random() * domains.length)]
  const random = Math.floor(Math.random() * 1000)
  return `${prefix}${random}.${domain}`
}

// 生成随机IP地址
function randomIP() {
  return Array(4).fill(0).map(() => Math.floor(Math.random() * 256)).join('.')
}

// 生成随机平台列表
function randomPlatforms() {
  const platforms = ['Windows', 'Mac', 'Linux', 'Android', 'iOS']
  const count = Math.floor(Math.random() * 3) + 1
  const result = []
  while (result.length < count) {
    const platform = platforms[Math.floor(Math.random() * platforms.length)]
    if (!result.includes(platform)) {
      result.push(platform)
    }
  }
  return result
}

// 生成随机日期
function randomDate(start, end) {
  const startDate = start ? new Date(start) : new Date('2023-01-01')
  const endDate = end ? new Date(end) : new Date('2024-12-31')
  const randomDate = new Date(startDate.getTime() + Math.random() * (endDate.getTime() - startDate.getTime()))
  return randomDate.toISOString().split('T')[0]
}

// 生成授权数据
export function generateMockData(count = 15, status = '正常') {
  // 生成10条正常数据和5条过期数据
  const normalData = generateAuthData(10, '正常')
  const expiredData = generateAuthData(5, '已过期')
  
  return [...normalData, ...expiredData]
}

// 生成指定状态的授权数据
function generateAuthData(count, status) {
  return Array(count).fill(0).map((_, index) => {
    // 生成授权编号 (年月日+4位随机数)
    const date = new Date()
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const random = String(Math.floor(Math.random() * 10000)).padStart(4, '0')
    const auth_code = `${year}${month}${day}${random}`

    // 生成授权码 (10位随机字母数字)
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    const auth_number = Array(10).fill(0).map(() => chars[Math.floor(Math.random() * chars.length)]).join('')

    // 生成到期时间
    let expire_date
    if (status === '正常') {
      // 生成30-365天后的日期
      expire_date = new Date(Date.now() + (30 + Math.floor(Math.random() * 335)) * 24 * 60 * 60 * 1000)
    } else {
      // 生成1-30天前的日期
      expire_date = new Date(Date.now() - (1 + Math.floor(Math.random() * 29)) * 24 * 60 * 60 * 1000)
    }

    return {
      id: index + 1,
      auth_code,
      auth_number,
      client_name: `${status === '正常' ? '测试' : '已过期'}客户${index + 1}`,
      phone: randomPhone(),
      domain: randomDomain(),
      ip_address: randomIP(),
      platform_limit: Math.random() > 0.3 ? Math.floor(Math.random() * 5) + 1 : 0,
      expire_date: expire_date.toISOString().split('T')[0],
      status: status,
      created_at: new Date().toISOString().split('T')[0],
      tool_plugins: randomPlugins(['customer_app', 'delivery_app', 'merchant_app', 'admin_app', 'platform_diy', 'miniprogram', 'cloud_goods']),
      business_plugins: randomPlugins(['errands', 'regional_agent', 'points_mall', 'takeout_promotion', 'shop_staff', 'life_circle', 'area_limit', 'multi_delivery', 'fixed_delivery_time']),
      marketing_plugins: randomPlugins(['delivery_card', 'share_rewards', 'free_meal', 'order_rewards', 'combo_red_packet', 'lucky_wheel', 'merchant_card', 'order_bonus', 'super_red_packet', 'member_red_packet'])
    }
  })
}

// 随机选择插件
function randomPlugins(plugins) {
  const count = Math.floor(Math.random() * plugins.length) + 1
  const result = []
  while (result.length < count) {
    const plugin = plugins[Math.floor(Math.random() * plugins.length)]
    if (!result.includes(plugin)) {
      result.push(plugin)
    }
  }
  return result
}

// 生成回收站数据
export function generateRecycleData(count = 10) {
  return Array(count).fill(0).map((_, index) => {
    // 生成授权编号 (年月日+4位随机数)
    const date = new Date()
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const random = String(Math.floor(Math.random() * 10000)).padStart(4, '0')
    const auth_code = `${year}${month}${day}${random}`

    // 生成授权码 (10位随机字母数字)
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    const auth_number = Array(10).fill(0).map(() => chars[Math.floor(Math.random() * chars.length)]).join('')

    return {
      id: count + index + 1,
      auth_code,
      auth_number,
      client_name: `已删除客户${index + 1}`,
      phone: randomPhone(),
      domain: randomDomain(),
      ip_address: randomIP(),
      platform_limit: Math.random() > 0.3 ? Math.floor(Math.random() * 5) + 1 : 0,
      expire_date: randomDate('2023-01-01', '2023-06-30'),
      status: '已过期',
      created_at: randomDate('2023-01-01', '2023-12-31'),
      deleted_at: randomDate('2023-07-01', '2023-12-31'),
      tool_plugins: randomPlugins(['customer_app', 'delivery_app', 'merchant_app', 'admin_app', 'platform_diy', 'miniprogram', 'cloud_goods']),
      business_plugins: randomPlugins(['errands', 'regional_agent', 'points_mall', 'takeout_promotion', 'shop_staff', 'life_circle', 'area_limit', 'multi_delivery', 'fixed_delivery_time']),
      marketing_plugins: randomPlugins(['delivery_card', 'share_rewards', 'free_meal', 'order_rewards', 'combo_red_packet', 'lucky_wheel', 'merchant_card', 'order_bonus', 'super_red_packet', 'member_red_packet'])
    }
  })
}

// 分页数据
export function paginateData(data, page = 1, pageSize = 10) {
  const start = (page - 1) * pageSize
  const end = start + pageSize
  return {
    list: data.slice(start, end),
    total: data.length,
    page: page,
    pageSize: pageSize
  }
}

// 搜索数据
export function searchData(data, params) {
  let filteredData = [...data]
  
  // 按域名搜索
  if (params.domain) {
    const domainKeyword = params.domain.toLowerCase()
    filteredData = filteredData.filter(item => 
      item.domain.toLowerCase().includes(domainKeyword)
    )
  }
  
  // 按手机号搜索
  if (params.phone) {
    filteredData = filteredData.filter(item => 
      item.phone.includes(params.phone)
    )
  }
  
  return filteredData
}

// 过期状态筛选
export function filterByExpireStatus(data, status) {
  return data.filter(item => item.status === status)
}

// 生成授权编号
function generateAuthCode() {
  const date = new Date()
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const random = String(Math.floor(Math.random() * 10000)).padStart(4, '0')
  return `${year}${month}${day}${random}`
}

// 生成授权码
function generateAuthNumber() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  return Array(10).fill(0).map(() => chars[Math.floor(Math.random() * chars.length)]).join('')
}

// 生成测试数据
export function generateTestData() {
  const storage = {
    getAuthList: () => JSON.parse(localStorage.getItem('auth_list') || '[]'),
    setAuthList: (list) => localStorage.setItem('auth_list', JSON.stringify(list)),
    getAuthRecycle: () => JSON.parse(localStorage.getItem('auth_recycle') || '[]'),
    setAuthRecycle: (list) => localStorage.setItem('auth_recycle', JSON.stringify(list))
  }

  // 生成授权列表数据（30条正常记录）
  const authList = Array(30).fill(null).map((_, index) => {
    // 生成30-365天后的到期日期
    const expireDate = new Date(Date.now() + (30 + Math.floor(Math.random() * 335)) * 24 * 60 * 60 * 1000)
    
    return {
      id: index + 1,
      auth_code: generateAuthCode(),
      auth_number: generateAuthNumber(),
      client_name: `测试客户${index + 1}`,
      phone: randomPhone(),
      domain: randomDomain(),
      ip_address: randomIP(),
      platform_limit: Math.floor(Math.random() * 5) + 1,
      expire_date: expireDate.toISOString().split('T')[0],
      status: '正常',
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      tool_apps: randomPlugins(['customer_app', 'delivery_app', 'merchant_app', 'admin_app', 'platform_diy', 'miniprogram', 'cloud_goods']),
      business_apps: randomPlugins(['errands', 'regional_agent', 'points_mall', 'takeout_promotion', 'shop_staff', 'life_circle', 'area_limit', 'multi_delivery', 'fixed_delivery_time']),
      marketing_apps: randomPlugins(['delivery_card', 'share_rewards', 'free_meal', 'order_rewards', 'combo_red_packet', 'lucky_wheel', 'merchant_card', 'order_bonus', 'super_red_packet', 'member_red_packet'])
    }
  })

  // 生成回收站数据（15条记录）
  const recycleList = Array(15).fill(null).map((_, index) => {
    // 生成1-30天前的删除时间
    const deleteTime = new Date(Date.now() - (1 + Math.floor(Math.random() * 29)) * 24 * 60 * 60 * 1000)
    // 生成已过期的记录
    const expireDate = new Date(deleteTime.getTime() - Math.floor(Math.random() * 30) * 24 * 60 * 60 * 1000)
    
    return {
      id: index + 31, // 避免ID重复
      auth_code: generateAuthCode(),
      auth_number: generateAuthNumber(),
      client_name: `已删除客户${index + 1}`,
      phone: randomPhone(),
      domain: randomDomain(),
      ip_address: randomIP(),
      platform_limit: Math.floor(Math.random() * 5) + 1,
      expire_date: expireDate.toISOString().split('T')[0],
      status: '已过期',
      created_at: new Date(expireDate.getTime() - 90 * 24 * 60 * 60 * 1000).toISOString(),
      updated_at: deleteTime.toISOString(),
      deleteTime: deleteTime.toISOString(),
      tool_apps: randomPlugins(['customer_app', 'delivery_app', 'merchant_app', 'admin_app', 'platform_diy', 'miniprogram', 'cloud_goods']),
      business_apps: randomPlugins(['errands', 'regional_agent', 'points_mall', 'takeout_promotion', 'shop_staff', 'life_circle', 'area_limit', 'multi_delivery', 'fixed_delivery_time']),
      marketing_apps: randomPlugins(['delivery_card', 'share_rewards', 'free_meal', 'order_rewards', 'combo_red_packet', 'lucky_wheel', 'merchant_card', 'order_bonus', 'super_red_packet', 'member_red_packet'])
    }
  })

  // 保存数据
  storage.setAuthList(authList)
  storage.setAuthRecycle(recycleList)

  return {
    authList,
    recycleList
  }
}

export default {
  generateMockData,
  generateRecycleData,
  paginateData,
  searchData,
  filterByExpireStatus,
  generateTestData
} 